(function($) {
  $(() => {
    $('#contactform').on('submit', function(e) {
      e.preventDefault();
      $(this)
        .find('.fs-submit')
        .addClass('loading');
      const budget = $('#contactform #q6')
        .val()
        .split(',');

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: ACForm.ajaxUrl,
        data: {
          action: 'contact_form', // calls wp_ajax_nopriv_contact_form
          username: $('#contactform #q1').val(),
          company: $('#contactform #q2').val(),
          need: $('#contactform #q3').val(),
          email: $('#contactform #q4').val(),
          tel: $('#contactform #q5').val(),
          budget: $('#contactform #q6').val(),
          budgetmin: budget[0],
          budgetmax: budget[1],
        },
      })
        .done(() => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'formSubmissionSuccess',
            formId: 'contactForm',
            value: (parseInt(budget[0]) + parseInt(budget[1])) / 2,
          });
        })

        .fail(() => {})
        .always(() => {
          const tl = new TimelineLite();
          $('.contact-content .textwidget').html(
            '<div class="merci"><h1>Merci !</h1><h3>Vos réponses ont bien été envoyées.</h3><p>Nous allons vous contacter dans les 24h ouvrées pour fixer un rendez-vous téléphonique et discuter de votre projet.</p></div>'
          );
          $('#contact-overlay').removeClass('active');
          tl.delay(6)
            .to('#contact-overlay .close', 0.15, {
              className: '-=open',
              onComplete() {
                $('html').css('overflow-y', 'auto');
                $('#contact-overlay .contact-content').css(
                  'overflow-y',
                  'hidden'
                );
              },
            })
            .to('#contact-overlay', 0.3, {
              x: '100%',
              ease: Power4.easeIn,
              onComplete() {
                $('header, .content, footer').removeClass('blurred');
                $('.sumome-share-client-wrapper').show();
              },
            });
        });
    });
  });
})(jQuery);
